import React from 'react';
import { Shield, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700 mb-4 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-blue-50 rounded-lg">
              <Shield className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Privacy Policy</h1>
              <p className="text-sm text-gray-500 mt-0.5">AI SENSE, Inc.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sm:p-8 space-y-8">
          <p className="text-sm text-gray-500">Effective Date: February 14, 2026</p>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">1. Information We Collect</h2>
            <p className="text-gray-600 leading-relaxed">
              We may collect the following types of information:
            </p>
            <ul className="mt-2 space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1.5 text-xs">&#9679;</span>
                Name, email address, and phone number
              </li>
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1.5 text-xs">&#9679;</span>
                Business information
              </li>
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1.5 text-xs">&#9679;</span>
                Website usage data and analytics
              </li>
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1.5 text-xs">&#9679;</span>
                Cookies and device identifiers
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">2. How We Use Information</h2>
            <p className="text-gray-600 leading-relaxed">
              We use the information we collect to:
            </p>
            <ul className="mt-2 space-y-1.5 text-gray-600">
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1.5 text-xs">&#9679;</span>
                Respond to your inquiries and requests
              </li>
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1.5 text-xs">&#9679;</span>
                Improve website functionality and user experience
              </li>
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1.5 text-xs">&#9679;</span>
                Analyze website traffic and usage patterns
              </li>
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1.5 text-xs">&#9679;</span>
                Communicate updates and relevant information
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">3. Cookies & Tracking</h2>
            <p className="text-gray-600 leading-relaxed">
              We may use cookies and analytics tools to improve your user experience. Cookies are small
              data files stored on your device that help us understand how you interact with our website
              and services.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">4. Data Sharing</h2>
            <p className="text-gray-600 leading-relaxed">
              We do not sell your personal data. Information may be shared with trusted service providers
              who assist us in operating our website and services, or with legal authorities if required
              by law.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">5. Data Security</h2>
            <p className="text-gray-600 leading-relaxed">
              We implement reasonable safeguards to protect your data from unauthorized access,
              alteration, disclosure, or destruction. While no method of transmission over the
              internet is 100% secure, we strive to protect your personal information.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">6. Your Rights</h2>
            <p className="text-gray-600 leading-relaxed">
              You may request access to, correction of, or deletion of your personal data at any
              time by contacting us using the information provided below.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">7. Children's Privacy</h2>
            <p className="text-gray-600 leading-relaxed">
              Our website and services are not directed to children under the age of 13. We do not
              knowingly collect personal information from children under 13.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">8. Contact Us</h2>
            <p className="text-gray-600 leading-relaxed">
              If you have any questions about this Privacy Policy, please contact us at:
            </p>
            <div className="mt-3 p-4 bg-gray-50 rounded-lg">
              <p className="font-medium text-gray-900">AI SENSE, Inc.</p>
              <p className="text-gray-600 mt-1">Email: contact@aisenseusa.com</p>
              <p className="text-gray-600">Website: www.aisenseusa.com</p>
            </div>
          </section>
        </div>

        <p className="text-center text-xs text-gray-400 mt-6">
          &copy; {new Date().getFullYear()} AI SENSE, Inc. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
